// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"bc29ff9b","146":"bc29ff9b","596":"bc29ff9b","911":"bc29ff9b"}[chunkId] + ".chunk.css";
};